import React, { createContext, useState, useEffect } from "react"

export const AppContext = createContext()

export const AppProvider = ({ children }) => {
  const [status, setStatus] = useState("idle")
  const [token, setToken] = useState(false)

  const handleLogin = token => {
    setToken(token)
    setStatus("ready")
  }

  const handleLogout = () => {
    const _confirm = window.confirm(`Queres cerrar sesión?`)
    if (!_confirm) return false
    setToken(false)
    setStatus("logged_out")
    localStorage.removeItem(`token`)
  }

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem(`token`))
    if (token || process.env.GATSBY_STATIC) {
      setToken(token)
      setStatus("ready")
    } else {
      setStatus("logged_out")
    }
  }, [])

  return (
    <AppContext.Provider
      value={{
        status,
        handleLogin,
        handleLogout,
        token,
        setToken,
      }}
    >
      {children}
    </AppContext.Provider>
  )
}
